import React from "react";
import Skeleton from "react-loading-skeleton";
import ChartFilterBar from "./ChartFilterBar";

const SiteChartCard = ({
  title,
  subtitle,
  loading,
  isEmpty,
  emptyMessage = "No Data Found",
  filterFields,
  filterValues,
  onFilterChange,
  onFilterApply,
  filterOptions,
  children,
  compact = false,
}) => (
  <article className={`dashboard-v2__chart-card site-dashboard-v2__chart-card ${compact ? "site-dashboard-v2__chart-card--compact" : ""}`}>
    <div className="site-dashboard-v2__chart-head">
      <div>
        <h3>{title}</h3>
        {subtitle && <p className="dashboard-v2__chart-sub">{subtitle}</p>}
      </div>
      {filterFields?.length > 0 && (
        <ChartFilterBar
          fields={filterFields}
          values={filterValues}
          onChange={onFilterChange}
          onApply={onFilterApply}
          filterOptions={filterOptions}
        />
      )}
    </div>
    <div className="site-dashboard-v2__chart-body">
      {loading ? (
        <Skeleton height={compact ? 200 : 250} />
      ) : isEmpty ? (
        <p className="site-dashboard-v2__chart-empty">{emptyMessage}</p>
      ) : (
        children
      )}
    </div>
  </article>
);

export default SiteChartCard;
